import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import reportActions from '../../report/reportActions';

import { Button } from '../../components/buttons';
import { DataTable, Page, PageContent, PageHeader, Table } from '../../components/common';
import Utils, { SecurityRoles } from '../../common/utils';
import { ensureUserHasRoleAdminSite } from '../../auth/authComponents';

interface Props {
	actions: any;
	history: any;
	referrals: ReferralReportDto[];
}
class ReferralsPage extends React.Component<Props> {
	componentDidMount() {
		this.props.actions.fetchReferralReport();
	}

	download = () => {
		this.props.actions.fetchReferralReport().then(() => {
			const formattedReferrals = this.formatData(this.props.referrals);
			Utils.downloadCsv(formattedReferrals, 'Referrals.csv');
		});
	}
	formatData = (referrals: ReferralReportDto[]) => {
		const formattedReferrals = referrals.map(r => {
			return {
				Customer: r.customerName,
				Referred: r.referredName,
				Date: Utils.formatDate(r.date),
				Amount: Utils.formatCurrency(r.amount),
				ReferralStatus: r.referralStatus
			};
		});

		return formattedReferrals;
	}

	render() {
		return (
			<Page title="Referrals">
				<PageContent>
					<PageHeader title="Referrals" />
					<div className="content-set">
						{this.props.referrals.length > 0 &&
							<div className="table-options">
								<div className="btn-group table-filters">
									<div className="table-filter">
										<Button
											className="btn-outline-primary"
											onClick={this.download}
										>
											<span className="align-middle mx-2">Download</span>
										</Button>
									</div>
								</div>
							</div>
						}
						<DataTable
							TableComponent={p => <Table isDataTable={true}>{p.children}</Table>}
							columns={[
								{
									Header: 'Customer',
									accessor: 'customerName'
								},
								{
									Header: 'Referred',
									accessor: 'referredName'
								},
								{
									Header: 'Date',
									accessor: 'date',
									Cell: (row: any) => Utils.formatDate(row.value)
								},
								{
									Header: 'Amount',
									accessor: 'amount',
									Cell: (row: any) => `${Utils.formatCurrency(row.value)}`
								},
								{
									Header: 'Referral Status',
									accessor: 'referralStatus'
								}
							]}
							getTrProps={(state: any, rowInfo: any, column: any) => {
								return {
									className: 'tr'
								};
							}}
							data={this.props.referrals}
							noDataText="No referrals"
							resizable={true}
						/>
					</div>
				</PageContent>
			</Page>
		);
	}
}
function mapStateToProps(state: any) {
	return {
		referrals: state.report.referrals
	};
}
function mapDispatchToProps(dispatch: any) {
	const actions = { ...reportActions };
	return {
		actions: bindActionCreators(actions, dispatch)
	};
}
const connectedPage = connect(mapStateToProps, mapDispatchToProps)(ReferralsPage);
const roles = [SecurityRoles.Administrator, SecurityRoles.Agent];
export default ensureUserHasRoleAdminSite(connectedPage as any, roles);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/admin/reports/ReferralsPage.tsx